module.exports = __webpack_public_path__ + "img/logo-dark.48edb7af.png";